const it = {
    price: {
        title: 'Listino Prezzi',
        list: 'Elenco Listini Prezzi',
        mutateSubtitle: 'Modifica il listino prezzi',
        unitPrice: 'P. Unitario',
        unitPriceShort: 'Unit {unit}',
        percentagePrice: 'P. Percentuale',
        percentagePriceShort: 'Perc. {percentage}',
        fixedPrice: 'P. Fisso',
        fixedPriceShort: 'Fisso {fixed}',
        productModelOptionalPriceGroupMeasure: {
            title: 'Listino Prezzi - Modelli',
            mutateSubtitle: 'Modifica il listino prezzi relativo ai modelli',
            productModelName: 'Modello',
            materialType: 'Tipo Materiale',
            priceGroupMeasureName: 'Listino Prezzi - Misure',
            optionalTelaioName: '@:optional.optionalType.TELAIO',
            optionalDogaName: '@:optional.optionalType.DOGA',
            optionalSpallaName: '@:optional.optionalType.SPALLA',
            optionalAperturaName: '@:optional.optionalType.APERTURA',
            price: 'Prezzo',
            alreadyExistsError: 'Esiste già un listino prezzi per questo modello, tipologia, doga e spalla.'
        },
        priceType: {
            label: 'Tipo di Prezzo',
            NONE: 'Nessuno',
            UNIT: 'Unitario',
            FIXED: 'Una tantum',
            PERCENTAGE: 'Percentuale',
            MIXUP: 'Misto (Unitario + Percentuale)',
            MIXFP: 'Misto (Una tantum + Percentuale)',
            MIXUF: 'Misto (Unitario + Una tantum)',
            QUOTE_FIXED: 'Una tantum Ordine/Preventivo',
            QUOTE_PERCENTAGE: 'Percentuale su totale',
            //QUOTE_MIXUP: 'Prezzo Misto (Unitario + Percentuale) Ordine/Preventivo',
            QUOTE_FIXEDP: 'Misto (Una tantum + Percentuale su totale) ',
        },
        priceTypeShort: {
            label: 'Tipo',
            NONE: 'No',
            UNIT: 'Unit {unit}',
            FIXED: 'Una tantum {fixed}',
            PERCENTAGE: 'Perc. {percentage}',
            MIXUP: 'Unit {unit} + Perc. {percentage}',
            MIXFP: 'Una tantum {fixed} + Perc. {percentage}',
            MIXUF: 'Unit {unit} + Una tantum {fixed}',
            QUOTE_FIXED: 'Fisso {fixed}',
            QUOTE_PERCENTAGE: 'Perc. {percentage}',
            QUOTE_FIXEDP: 'Fisso {fixed} + Perc. {percentage}',
        }

    },
    priceGroupMeasure: {

        list: 'Listini Prezzi - Misure',
        title: 'Listino Prezzi - Misure',
        mutateTitle: 'Modifica Listino Prezzi - Misure',
        mutateSubtitle: 'Modifica il listino prezzi relativo alle misure',
        name: 'Nome',
        code: 'Codice',
        description: 'Descrizione',
        isDefault: 'Predefinito',
        measureGroup: 'Gruppo Misure',
        selectorTitle: 'Seleziona Listino Misure',
    },
    priceMeasure: {
        id: 'ID',
        list: 'Listini Prezzi - Misure',
        title: 'Listino Prezzi - Misure',
        mutateTitle: 'Modifica Listino Prezzi - Misure',
        axisY: 'Altezza',
        axisX: 'Larghezza',
        price: 'Prezzo',
        axisYMin: 'Altezza Min',
        axisYMax: 'Altezza Max',
        axisXMin: 'Larghezza Min',
        axisXMax: 'Larghezza Max',
        priceFrom: 'Prezzo da',
        priceTo: 'Prezzo a',
        mutateSubtitle: 'Modifica il listino prezzi relativo alle misure',
        noData: 'Nessun dato per questo listino prezzi - misure. Aggiungi nuove misure per questo listino prezzi.',
    }
}

export default it;